const wrapper = "_35swrlyek4";
const splitviewWrapper = "_35ss1w0v0xz";
const linebreak = "_35slkdly7g";

export { linebreak, splitviewWrapper, wrapper };
import "./_task.in-text.style.linaria.module.css";
//# sourceMappingURL=_task.in-text.style.js.map
